import React from 'react';
import styled from 'styled-components';
import { Root as ChipRoot } from './Chip.styled';
import { chipTheme } from './theme';
export const Root = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin-top: -${chipTheme.list.spacing};

  > ${ChipRoot} {
    margin-top: ${chipTheme.list.spacing};
  }

  > ${ChipRoot}:not(:last-child) {
    margin-right: ${chipTheme.list.spacing};
  }
`;
/** The purpose of this component is to display list of `Chip` component with the spacing between `Chip`s */
export const ChipsList = styled(({ children, className, rootProps }) => (React.createElement(Root, Object.assign({ className: className }, rootProps), children))) ``;
//# sourceMappingURL=ChipsList.js.map